<template>
  <div class="workorderlist">
    <div class="list">
      <div class="item" v-for="item in workorderlist" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import workorderlist1 from "../../../../assets/product/workorderlist1.png";
import workorderlist2 from "../../../../assets/product/workorderlist2.png";
import workorderlist3 from "../../../../assets/product/workorderlist3.png";
import workorderlist4 from "../../../../assets/product/workorderlist4.png";

export default {
  setup() {
    return reactive({
      workorderlist: [
        {
          id: 1,
          title: "自助服务",
          logo: workorderlist1,
        },
        {
          id: 2,
          title: "智能派单",
          logo: workorderlist2,
        },
        {
          id: 3,
          title: "仓储联动",
          logo: workorderlist3,
        },
        {
          id: 4,
          title: "流程闭环",
          logo: workorderlist4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.workorderlist {
  width: 1180px;
  margin: 80px auto 0;
}
.workorderlist .list {
    display: flex;
    justify-content: space-between;
}
.workorderlist .list .item {
    text-align: center;
    overflow: hidden;
}
.workorderlist .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.workorderlist .list .item img {
    width: 280px;
}
.workorderlist .list .item div {
    margin-top: 20px;
    font-size: 16px;
}
</style>
